import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const MyListings = React.lazy(() => import('../pages/MyListings'));
const MyRequests = React.lazy(() => import('../pages/MyRequests'));
const CreateListing = React.lazy(() => import('../pages/CreateListing'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const listingsRequestsRoutes = (
  <>
    <Route path="/my-listings" element={<SuspenseWrapper><MyListings /></SuspenseWrapper>} />
    <Route path="/my-requests" element={<SuspenseWrapper><MyRequests /></SuspenseWrapper>} />
    <Route path="/create-listing" element={<SuspenseWrapper><CreateListing /></SuspenseWrapper>} />
    <Route path="/edit-listing/:id" element={<SuspenseWrapper><CreateListing /></SuspenseWrapper>} />
  </>
);
